import styled from "styled-components";
import logoLarge from "../assets/logo-512.png";
import linkedInLogo from "../assets/linkedin.png";
import instagramLogo from "../assets/instagram.png";
import facebookLogo from "../assets/facebook.png";
import twiterXLogo from "../assets/twiterX.png";
import { getWebsiteData } from "../adapters/WebsiteDataAdapter";
import { useEffect, useState } from "react";
import { analytics } from "../firebase";
import { logEvent } from "firebase/analytics";

const Footer = () => {
  const [websiteData, setWebsiteData] = useState();

  useEffect(() => {
    getWebsiteData().then((data) => setWebsiteData(data));
  }, []);

  return (
    <FooterContainer>
      <FooterContent>
        {/* LEFT */}
        <ContactInfoContainer>
          <ContactTitle>Kontakt</ContactTitle>

          {websiteData && (
            <>
              <ContactInfo
                href={websiteData.googleAddress}
                target="_blank"
                rel="noopener noreferrer"
              >
                Adresa: {websiteData.address}
              </ContactInfo>

              <ContactInfo
                href={"tel:" + websiteData.phoneNumber}
                onClick={() =>
                  logEvent(analytics, "user_interaction", {
                    firebase_screen: "PhoneNumber",
                  })
                }
              >
                Telefon: {websiteData.phoneNumber}
              </ContactInfo>

              <ContactInfo
                href={"mailto:" + websiteData.email}
                onClick={() =>
                  logEvent(analytics, "user_interaction", {
                    firebase_screen: "Email",
                  })
                }
              >
                Email: {websiteData.email}
              </ContactInfo>
            </>
          )}
        </ContactInfoContainer>

        {/* CENTER */}
        <FooterCentralContent>
          <Logo src={logoLarge} />
          <LogoTitle>Ogledalo Drustva</LogoTitle>
          {websiteData && (
            <LogoTextSmall>{websiteData.catchPhrase}</LogoTextSmall>
          )}
        </FooterCentralContent>

        {/* RIGHT (SPLIT INTO TWO) */}
        <RightContainer>
          {/* LEFT PART (NAVIGATION) */}
          <NavColumn>
            <ColumnTitle>Navigacija</ColumnTitle>
            <FooterLink href="/">Početna</FooterLink>
            <FooterLink href="/projects">Projekti</FooterLink>
            <FooterLink href="/about">O nama</FooterLink>
            <FooterLink href="/contact">Kontakt</FooterLink>
            <FooterLink href="/impressum">Impresum</FooterLink>
          </NavColumn>

          {/* RIGHT PART (SOCIALS) */}
          <SocialColumn>
            <ColumnTitle>Zapratite nas</ColumnTitle>

            <SocialRow>
              {websiteData?.facebookLink && (
                <a
                  href={websiteData.facebookLink}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() =>
                    logEvent(analytics, "user_interaction", {
                      firebase_screen: "Facebook",
                    })
                  }
                >
                  <SocialMediaLink src={facebookLogo} />
                </a>
              )}

              {websiteData?.instagramLink && (
                <a
                  href={websiteData.instagramLink}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() =>
                    logEvent(analytics, "user_interaction", {
                      firebase_screen: "Instagram",
                    })
                  }
                >
                  <SocialMediaLink src={instagramLogo} />
                </a>
              )}

              {websiteData?.linkedinLink && (
                <a
                  href={websiteData.linkedinLink}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() =>
                    logEvent(analytics, "user_interaction", {
                      firebase_screen: "LinkedIn",
                    })
                  }
                >
                  <SocialMediaLink src={linkedInLogo} />
                </a>
              )}

              {websiteData?.twitterLink && (
                <a
                  href={websiteData.twitterLink}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() =>
                    logEvent(analytics, "user_interaction", {
                      firebase_screen: "Twitter",
                    })
                  }
                >
                  <SocialMediaLink src={twiterXLogo} />
                </a>
              )}
            </SocialRow>
          </SocialColumn>
        </RightContainer>
      </FooterContent>

      <Copyright>© 2025 Memento Tech</Copyright>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid ${(props) => props.theme.colors.border};
  padding-top: 2rem;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  max-width: 1200px;

  @media screen and (max-width: ${(props) => props.theme.screen.medium}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
`;

const FooterCentralContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  width: 180px;
`;

const LogoTitle = styled.h3`
  font-size: 2rem;
  font-weight: 300;
  margin: 10px;
`;

const LogoTextSmall = styled.p`
  font-style: italic;
  text-align: center;
`;

const ContactInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ContactTitle = styled.p`
  font-weight: 600;
  margin-bottom: 10px;
`;

const ContactInfo = styled.a`
  margin-bottom: 5px;
  color: inherit;
  text-decoration: none;
`;

const RightContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  gap: 2rem;

  @media screen and (max-width: ${(props) => props.theme.screen.medium}) {
    flex-direction: column;
    align-items: center;
  }
`;

const NavColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

const SocialColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ColumnTitle = styled.p`
  font-weight: 600;
  margin-bottom: 10px;
`;

const FooterLink = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.textSecondary || "#666"};
  font-size: 0.95rem;

  &:hover {
    text-decoration: underline;
  }
`;

const SocialRow = styled.div`
  display: flex;
  gap: 10px;
`;

const SocialMediaLink = styled.img`
  width: 40px;
  cursor: pointer;
`;

const Copyright = styled.p`
  margin-top: 2rem;
  font-weight: 100;
`;
